import type { DocumentRecord, MembershipRole, SettableMemberStatus } from "@shyne/shared/api";
import { ReadAllResponse, uuid } from "@/interfaces";
import { TeamMembersRepository, type TeamMember } from "@/repositories/team-members.repository.ts";

export async function getTeamMemberDetail(memberId: uuid) {
  return TeamMembersRepository.getDetail(memberId);
}

export async function changeRoleAndStatus(member: TeamMember, role: MembershipRole, status: SettableMemberStatus | undefined): Promise<TeamMember> {
  const withRole = role === member.role ? member : await TeamMembersRepository.setRole(member.id, role);
  return status === undefined || status === withRole.details?.status ? withRole : TeamMembersRepository.setStatus(member.id, status);
}

export async function getTeamMember(memberId: uuid): Promise<TeamMember> {
  return TeamMembersRepository.get(memberId);
}

export async function uploadDocumentForUser(person: uuid, file: File, expiresAt?: string | Date) {
  return TeamMembersRepository.uploadDocument(person, file, expiresAt);
}

export async function deleteDocumentForUser(docId: uuid) {
  return TeamMembersRepository.deleteDocument(docId);
}

export async function listUserDocuments(person: uuid, page: number, pageSize: number): Promise<ReadAllResponse<DocumentRecord>> {
  return TeamMembersRepository.listDocuments(person, page, pageSize);
}
